import {
	ADMINCREATERISKRULEMAPPING_SUCCESS,
	ADMINCREATERISKRULEMAPPING_FAILED,
	RESET_ADMINCREATERISKRULEMAPPING,
	LOADING_ADMINCREATERISKRULEMAPPING,
	NETWORK_ERROR_ADMINCREATERISKRULEMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINCREATERISKRULEMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINCREATERISKRULEMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINCREATERISKRULEMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINCREATERISKRULEMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINCREATERISKRULEMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
